import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

const useURLPaginate = PAGINATION => {
  if (!PAGINATION) {
    throw new Error('PAGINATION parameter is required for useURLPaginate');
  }
  const [searchParams] = useSearchParams();

  const page = parseInt(searchParams.get('page') || PAGINATION.PAGE_INDEX, 10);
  const limit = parseInt(searchParams.get('limit') || PAGINATION.PAGE_SIZE, 10);
  const sorting = useMemo(() => {
    try {
      const sortParam = searchParams.get('sorting');
      return sortParam ? JSON.parse(sortParam) : [];
    } catch {
      return [];
    }
  }, [searchParams]);

  const filters = useMemo(() => {
    try {
      const filterParam = searchParams.get('filters');
      return filterParam ? JSON.parse(filterParam) : {};
    } catch {
      return [];
    }
  }, [searchParams]);

  return {
    page,
    filters,
    limit,
    sorting,
  };
};

export default useURLPaginate;
